module.exports = __webpack_public_path__ + "static/media/APCO Logo Intl Logo_1719597540477.ef59bf9c.png";